import React from "react";
import { AlertTriangle, CheckCircle2, XCircle } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import "./StatusChip.css";

type StatusChipProps = {
  title: string;
  status: "ok" | "warning" | "error" | "blocked";
  description: string;
};

type StatusConfig = {
  Icon: LucideIcon;
  className: string;
};

const statusMap: Record<StatusChipProps["status"], StatusConfig> = {
  ok: {
    Icon: CheckCircle2,
    className: "status-chip--ok",
  },
  warning: {
    Icon: AlertTriangle,
    className: "status-chip--warning",
  },
  error: {
    Icon: XCircle,
    className: "status-chip--error",
  },
  blocked: {
    Icon: XCircle,
    className: "status-chip--blocked",
  },
};

const StatusChip: React.FC<StatusChipProps> = ({ title, status, description }) => {
  const { Icon, className } = statusMap[status];

  return (
    <div className={`status-chip ${className}`}>
      <span className="status-chip__icon" aria-hidden>
        <Icon size={16} strokeWidth={2.2} />
      </span>
      <div className="status-chip__text">
        <span className="status-chip__title">{title}</span>
        <span className="status-chip__description">{description}</span>
      </div>
    </div>
  );
};

export default StatusChip;
